import { Box, Grid, Typography } from '@mui/material'
import { StockProjectionExcessGraph } from 'Features/NewDashboard/StockBuild/StockBuild.graph'
import { useTheme } from '@mui/material/styles'
import { useParams } from 'react-router-dom'
import { useExcessData } from './SourceSiteDashboard.data'
import { Loader } from 'Common/Loader/Loader'
import {
  GraphViewProps,
  SourceSiteDashboardPageURLParams,
} from './SourceSiteDashboard.types'
import { formatDateWithHiphen } from 'Common/utils/utils'

export const StockBuildView = ({ workcentresList }: GraphViewProps) => {
  const theme = useTheme()
  const { planId } = useParams<SourceSiteDashboardPageURLParams>()
  const { data: ExcessData, isLoading: stockBuildDataLoading } = useExcessData(
    planId ?? '',
    workcentresList
  )
  const kpis = ExcessData?.kpis ?? {}
  if (stockBuildDataLoading) {
    return <Loader />
  }
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Grid container>
        <Grid size={4}>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            Total excess
          </Typography>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            volume
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}
          >
            {kpis?.excessStockAmount?.toFixed(2) ?? 0}
          </Typography>
        </Grid>
        <Grid size={4}>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            Average planned
          </Typography>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            stock build
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}
          >
            {kpis?.avgExcessStockAmount?.toFixed(2) ?? 0}
          </Typography>
        </Grid>
        <Grid size={4}></Grid>
      </Grid>
      <Box>
        <StockProjectionExcessGraph
          traceOneName={'Excess'}
          traceTwoName={'Minimum Inventory'}
          traceThreeName={'Safety Stock'}
          traceFourName={'Week Start Inventory'}
          xAxisData={
            ExcessData?.productionDate?.map(formatDateWithHiphen) ?? []
          }
          excess={ExcessData?.excess ?? []}
          minimumInventory={ExcessData?.constrainedHours ?? []}
          safetyStockVolume={ExcessData?.safetyStockVolume ?? []}
          weekStartInventory={ExcessData?.weekStartInventory ?? []}
        />
      </Box>
    </Box>
  )
}
